import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'aw-browser-tab-preview',
  templateUrl: './browser-tab-preview.component.html',
  styles: `
    :host {
      display: block;
    }

    :host .material-symbols-rounded {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      vertical-align: middle;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowserTabPreviewComponent {
  public readonly title: InputSignal<string> = input('Webshop');
  public readonly faviconUrl: InputSignal<string> = input('');
  public readonly address: InputSignal<string> = input('www.example.com');
}
